import { createContext } from 'react';

const LoginContext = createContext<boolean>(false);

interface LoginProviderProps {
  children: React.ReactNode;
  value?: boolean;
}

function LoginProvider({ children, value = false }: LoginProviderProps) {
  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
}

export { LoginContext, LoginProvider };
